import { Overlay } from '@angular/cdk/overlay';
import { Component } from '@angular/core';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { Address } from 'src/app/modules/route-planner/interfaces/location/address.interface';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';
import { BaseAutoCompleteComponent } from '../../../base-auto-complete.component';
import { FavoritesService } from 'src/app/modules/route-planner/services/favorites/favorites.service';
import { eFavoriteType } from 'src/app/modules/route-planner/enums/favorite/favorite-type.enum';

export abstract class BaseAddressAutoCompleteComponent extends BaseAutoCompleteComponent<Address> {
  constructor(
    favoritesService: FavoritesService,
    routePlanningService: RoutePlanningService,
    resizeService: ResizeService,
    overlay?: Overlay
  ) {
    super(favoritesService, routePlanningService, resizeService, overlay);
  }

  displayValueName(address: Address) {
    return !!address &&
      !!address.addressDetails &&
      !!address.addressDetails.label
      ? address.addressDetails.label
      : '';
  }

  override insertChosenValueToStorage(address: Address) {
    let favoriteAddresses = this.favoritesService.favorites?.addresses;

    if (!favoriteAddresses?.lastSearches) {
      favoriteAddresses = {
        ...favoriteAddresses,
        type: eFavoriteType.ADDRESSES,
        lastSearches: [],
      };
    }

    if (
      favoriteAddresses.lastSearches.length >= this.FEED_LAST_SEARCHES_AMOUNT
    ) {
      favoriteAddresses.lastSearches.pop();
    }

    if (
      !favoriteAddresses.lastSearches.find(
        (search) => search.addressDetails.label === address.addressDetails.label
      )
    ) {
      favoriteAddresses.lastSearches.unshift({
        ...address,
        type: eFavoriteType.LAST_SEARCH,
      });
    }

    this.favoritesService.updateFavorite(favoriteAddresses);
  }
}
